export const areArraysEqual = (arr1?: unknown[], arr2?: unknown[]): boolean => {
  if (!arr1 && !arr2) {
    return true;
  }

  if (!arr1 || !arr2) {
    return false;
  }

  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every((value) => arr2.includes(value)) && arr2.every((value) => arr1.includes(value));
};
